import React, { Component } from 'react';
import Immutable from 'immutable';
import Dfp from './Dfp';
import TopTags from './TopTags';
import 'whatwg-fetch';

class Articles extends Component {
 
	 constructor(){
		  super();
		  this.state = {
			  list:Immutable.List([]),
              page:1,
              searchTxt:( document.querySelector('meta[name="searchTxt"]') ? document.querySelector('meta[name="searchTxt"]').content : false ),
			  loading:false,
			  nextPage:true,
			  articleColumn:2,
			  tagList: []
		  }

          let page = document.querySelector('meta[name="page"]').content;
		  this.page = page;

		  this.isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
		  this.parentCategory = document.querySelector('meta[name="category"]')? document.querySelector('meta[name="category"]').content : '';

		  let popularTag = document.getElementById('popular-tag-mobile-top') && document.getElementById('popular-tag-mobile-top').dataset? document.getElementById('popular-tag-mobile-top').dataset.tags : '';
		  this.tagDataset = popularTag? JSON.parse(popularTag) : [];

          this.dfpList = [];
		  this.dfpCount = 0;
		  this.pagePlacement = page == 'home' ? 'homepage' : 'channels'
		  this.getLatestArticles = this.getLatestArticles.bind(this);
		  this.isScrolledIntoView = this.isScrolledIntoView.bind(this);
		  this.handleScroll = this.handleScroll.bind(this);
		  this.extractHostname = this.extractHostname.bind(this);
		  this.getChannelURL = this.getChannelURL.bind(this);
		  this.dfpUpdate = this.dfpUpdate.bind(this);
		  this.dfpReady = this.dfpReady.bind(this);
		  this.getTags = this.getTags.bind(this);
	}
	getLatestArticles() {
        const {page, loading, searchTxt, nextPage, articleColumn} = this.state;
        const {author, catId, section, apiLabel, baseurl} = this.props;

        let that = this;

		if (!loading && nextPage) {
			let params;

			if (section == 'she-promotes') {
				params = {
					promote: section,
					page: page
				};
			}
			else if (section == 'secret-talk') {
				params = {
					secret_talk: 1,
					page: page
				};
			} else if (section == 'term') {
				params = {
					term: document.querySelector('meta[name="term"]').content,
					page: page + 1,
					offset: 12
				};
				this.setState({searchTxt: document.querySelector('meta[name="term"]').content});
			} else if (section == 'shefluencer') {
                params = {
                    endpoint: document.querySelector('meta[name="endpoint"]').content,
                    page: page
                };
            } else if (searchTxt) {
				params = {
					search: decodeURIComponent(searchTxt),
					page: page
				};
			} else if (author != '') {
				params = {
					author: author,
					page: page
				};
			} else if (catId != 0) {
				params = {
					category: catId,
					page: page
				};
			} else {
				params = {
					home: 1,
					page: page
				};
			}

			let formData = new FormData();
			for (var k in params) {
				if (params.hasOwnProperty(k)) {
					formData.append(k, params[k]);
				}
			}

			this.setState({loading: true});

			if (document.getElementById('loading-bar')) {
				document.getElementById('loading-bar').className = '';
			}
			// Apply on all sites
			if (page == 1 /*&& (document.querySelector('meta[name="baseURL"]').content.indexOf('.she.com') != -1)*/ ) {

				that.setState({page: that.state.page + 1});
				that.setState({loading: false});

			} else {

				fetch(baseurl + '/wp-json/she-rest-api/' + apiLabel + '/', {
					method: "POST",
					body: formData
				}).then(function (res) {
					return res.json();
				})
				.then(function (response) {
					let arr = response.items;

					arr.forEach(function (item) {
						item.ad_post = false;
					});

					let tmpOffset = 0

					// insert banner items
					if (that.state.list.size == 0) {
						if (arr.length >= articleColumn) {
							arr.splice(articleColumn, 0, {ad_post: '300x250'});
							arr.splice(2 * articleColumn + 1, 0, {ad_post: 'placeholder'});
							tmpOffset += 2
						}
						if (arr.length > (3 * articleColumn + 1) + tmpOffset) {
							arr.splice((2 * (articleColumn + 1)), 0, {ad_post: 'placeholder'});
							arr.splice((3 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							arr.splice((4 * (articleColumn + 1)), 0, {ad_post: 'placeholder'});
							arr.splice((5 * (articleColumn + 1)), 0, {ad_post: 'placeholder'});
						}
					} else {
						if (arr.length >= articleColumn) {
							arr.splice(articleColumn, 0, {ad_post: '300x250'});
							arr.splice(2 * articleColumn + 1, 0, {ad_post: 'placeholder'});
							tmpOffset += 2
						}
						if (arr.length > (3 * articleColumn + 1) + tmpOffset) {
							arr.splice((2 * (articleColumn + 1)), 0, {ad_post: 'placeholder'});
							arr.splice((3 * (articleColumn + 1)), 0, {ad_post: '300x250'});
							arr.splice((4 * (articleColumn + 1)), 0, {ad_post: 'placeholder'});
							arr.splice((5 * (articleColumn + 1)), 0, {ad_post: 'placeholder'});
						}
					}

					that.setState({
						list: that.state.list.concat(Immutable.List(arr)),
						page: that.state.page + 1,
						loading: false
					});

					if (document.querySelector('.btn-loadmore')) {
						document.querySelector('.btn-loadmore').className = document.querySelector('.btn-loadmore').className + ' load';
					}

					if (document.getElementById('loading-bar')) {
						document.getElementById('loading-bar').className = 'done';
					}

					if (!response.next) {
						if (document.querySelector('.btn-loadmore')) {
							document.querySelector('.btn-loadmore').style.display = 'none';
						}
					}

					if (dataLayer && that.state.page > 1) {
						let tmpPageURL = window.location.href;
						dataLayer.push({
							virtualPageTitle: document.title + ' (LoadMore)',
							virtualPageURL: tmpPageURL.replace(/^.*\/\/[^\/]+/, ''),
							event: 'VirtualPageview'
						});
					}

					if (window.splashAd && document.getElementById('ad_splash-frame') && document.getElementById('ad_splash-frame').style.display == 'none')
						googletag.pubads().refresh([window.splashAd]);

					that.setState({nextPage: response.next})

				}).catch(function (error) {
					console.log(error);
				});

			}

		}
	}
	
	componentDidMount(){
		this.getLatestArticles();
		if(this.state.searchTxt == ''){
            window.addEventListener('scroll', this.handleScroll);
        }
		if (this.page == 'home' || this.page == 'category' || this.page == 'single') {
			this.getTags(this.tagDataset);
		}
	}
	
	componentWillUnmount(){
		window.removeEventListener('scroll', this.handleScroll);
	}

    dfpUpdate(){
        this.dfpCount++;
    }

    dfpReady(adunit){
        this.dfpList.push(adunit)

		if(this.dfpCount == this.dfpList.length){
            googletag.pubads().refresh(this.dfpList);
            this.dfpCount = 0;
            this.dfpList = [];
		}
	}
	
	isScrolledIntoView(elm,scrolltop){
		if(typeof elm == 'undefined') return;
        let docViewTop = scrolltop;
        let docViewBottom = docViewTop + ( window.outerHeight==0 ? window.innerHeight : window.outerHeight );

        let elemTop = elm.getBoundingClientRect().top+docViewTop;
        let elemBottom = elemTop + elm.getBoundingClientRect().height;
		
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
	
	handleScroll(evnt){
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		if(this.isScrolledIntoView(document.querySelectorAll('.block-article-loadmore')[0],scrollTop)){
			if(document.querySelector('.btn-loadmore')){
				document.querySelector('.btn-loadmore').className = document.querySelector('.btn-loadmore').className+' load';
			}
			this.getLatestArticles();
		}
	}

    extractHostname(url) {
        var hostname;
        //find & remove protocol (http, ftp, etc.) and get hostname

        if (url.indexOf("://") > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }

        //find & remove port number
        hostname = hostname.split(':')[0];
        //find & remove "?"
        hostname = hostname.split('?')[0];

        return hostname;
    }

    getChannelURL(label, url){
		let tmpURL = '';

		if(label!='she-mom' &&  label!='she-brides' && label!='kChannel' && label != 'luxshery'){
            tmpURL = '/'+label
		}else{
			tmpURL = ( url.indexOf('https://') == -1 ? 'http://' : 'https://' ) + this.extractHostname(url)
		}

		return tmpURL
	}
	
	compileURL( name, url ) {
		if (!url) url = location.href
		name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
		let regexS = "[\\?&]"+name+"=([^&#]*)";
		let regex = new RegExp( regexS );
		let results = regex.exec( url );
		return results == null ? null : results[1];
	}

	getTags(data){
		let that = this;

		if (this.state.tagList && this.state.tagList.length) {
			// console.log('tags already existed');
		} else if (data.length) {
			that.setState({tagList: data});
			// console.log('get tags from tagDataset : ', that.state.tagList);
		} else {
			fetch('/wp-json/she-rest-api/getHottestTags/', {
				method: "GET",
			}).then(function (res) {
				return res.json();
			}).then(function (response) {
				let arr = response.items.tags;
				that.setState({tagList: arr});
				// console.log('get tags from API : ', that.state.tagList);
			}).catch(function (error) {
				console.log(error);
			});
		}
	}

	renderGrid(item,index){
		const { theme, catId, subcat } = this.props;
		const { tagList } = this.state;
		let tmp
		let tmpGTMLabel = 'H';
		let that = this;
		let extraIcon = ''
		let extraRibbon = ''

		if(catId!=0){
			if(subcat==0){
				tmpGTMLabel = 'C'
			}else{
				tmpGTMLabel = 'SC'
			}
		}
        if(item.search_post){
            item.format=item.pagemap.metatags[0]['article:format'];
		}
		if(item.format=='video'){
            extraIcon = <div className="extra-icon">
						<i className="icon-play-01"></i>
					  </div>
		}
		if(item.format=='promote'){
            extraIcon = <div className="extra-icon">
						<i className="icon-gift"></i>
					  </div>
		}

		// category "shedates" only
		if(catId == 267343){
            if(item.format=='progress'){
                extraRibbon = <div className="ribbon ribbon-top-left in-progress"><span>In Progress</span></div>
                extraIcon = <a href={item.url}>
                    <div className="join-now">立即登記<i className="icon-arr_right-01"></i></div>
                </a>
            }else if(item.format=='full'){
                extraRibbon = <div className="ribbon ribbon-top-left full"><span>Full</span></div>
            }else{
                extraRibbon = <div className="ribbon ribbon-top-left past-event"><span>Past Event</span></div>
            }
		}

        if(!item.ad_post){
			tmp = 	<div className="grid-article">
				{extraRibbon}
				<a href={item.url} onClick={ () => that.linkInteractions(item.url,tmpGTMLabel+'/List')} title={item.post_title}>
					<div className="thumb-img-container">
                        <img className="thumb-img-cell" src={item.thumbnail_mobile} alt={item.post_title}/>
					</div>
				</a>
				<div className="desc-grid-article Abel">
					{extraIcon}
					<div className="clearfix">

						<ol className="info-list">
							<li><a className={item.category_slug} href={this.getChannelURL(item.category_slug, item.url)} style={{ color:item.category_color }} dangerouslySetInnerHTML={{ __html:item.category_name }}></a></li>
							<li>by <a href={item.author_url}>{item.author_name}</a></li>
							<li>{item.post_date}</li>
						</ol>

					</div>
					<a href={item.url} onClick={ () => that.linkInteractions(item.url,tmpGTMLabel+'/List')} title={item.post_title}>
						<h2 className="grid-article-title"  dangerouslySetInnerHTML={{ __html:item.post_title }}></h2>
					</a>
				</div>
			</div>
		}else if(item.ad_post==='300x250'){
			let setNum = ( index<3 ? 1 : 2 );
            // Apply on all sites
            // if(document.querySelector('meta[name="baseURL"]').content.indexOf('.she.com') != -1 || document.querySelector('meta[name="baseURL"]').content.indexOf('shemom.com') != -1){
				setNum = 2;
			// }
			tmp = <div className="grid-ads text-center">
					<div className="ad_300x250">
						{(this.page == 'home' || this.page == 'category' || this.page == 'single')?
							<div className={this.isMobile? "popular-tag-mobile":"popular-tag-desktop popular-tag-desktop-home"}>
								<TopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList}/>
							</div>
							: ''
						}
						<Dfp
							dfpReady={this.dfpReady}
            				dfpUpdate={this.dfpUpdate}
							adUnit={theme+'_' + this.pagePlacement + '_' + ( this.pagePlacement!='homepage' && setNum==1 ? 'ATF_set' : 'BTF_set' ) +setNum+'_300x250'}
							sizes={[[300,250],[300,600]]}
						/>					
					</div>
				</div>
		}else{
			tmp = <div className="grid-ads text-center">
					<div className="ad-placeholder"></div>
				</div>
		}
		
		return tmp
	}
		
	linkInteractions(url,type){
            if(dataLayer)
                dataLayer.push({event: 'linksection', virtualPageURL: url, linkSection: type});
	}
	
	 render() {
		 const { list, searchTxt, articleColumn, page } = this.state;
		 const { section, catId } = this.props;
		 let that = this;
		 let tmpArr = [];
		 let fullWidthCount = 0;

         // Apply on all sites
         // if(document.querySelector('meta[name="baseURL"]').content.indexOf('.she.com') != -1 || document.querySelector('meta[name="baseURL"]').content.indexOf('shemom.com') != -1){
             fullWidthCount++;
         // }
		 let loadBtn = '';

		 // if(this.state.searchTxt == ''){
		 	loadBtn = <div className="grid-article-content grid-article-content-loadmore">
                <div className="block-article-loadmore" onClick={this.getLatestArticles}>
                    <div className="btn btn-loadmore text-center Abel">
                        <div className="btn-loadmore-over"></div>
                        <div className="btn-loading">
                            <span className="modal-pulsate" id="modal-bit-loader"></span>
                        </div>
                        <span>load more<i className="icon-arr_down-01"></i></span>
                    </div>
                </div>
            </div>;
		 // }

		 if(list.size){

             return(
				<div>
					{
						list.map(function(item,index){
							tmpArr.push(item);
							
							if(((tmpArr.length===articleColumn+1) && index!==0) || ( index>=list.size-1)){
								let tmpGridsArticle = tmpArr.map(function(tmpItem,tmpIdx){	
									if(!tmpItem.ad_post){
										return (
											<div key={tmpIdx} className="grid-article-list">
												{that.renderGrid(tmpItem,index)}
											</div>
										)
									}
								});
								let tmpGridsAd = tmpArr.map(function(tmpItem,tmpIdx){	
									if(tmpItem.ad_post){
										return (
											<div key={tmpIdx} className="grid-article-list">
												{that.renderGrid(tmpItem,index)}
											</div>
										)
									}
								});
								
								tmpArr = [];
								
								let tmpAds = '';
								if(fullWidthCount==2){
									//fullWidthCount = 0;
								}

								if(fullWidthCount==0){
									tmpAds =
											<div className={ section=='she-promotes' ? 'she-promotes' : '' }>
												<div className="ad_970x90">
													<Dfp
                                    					dfpUpdate={that.dfpUpdate}
														dfpReady={that.dfpReady}
														adUnit={that.props.theme+'_' + that.pagePlacement + '_ATF_expand_970x90'}
														sizes={[[970,90],[970,550],[970,250],[728,90],[728,180],[320, 50],[320, 100],[300,250]]}
														sizeMapping={ [
															{viewport: [970, 0], sizes:[[728, 90],[728,180],[970,90],[970,250]]},
															{viewport: [0, 0], sizes:[[320, 50],[320, 100],[300,250]] }
															]}
													/>
												</div>
									{/*}
													<h2 className="text-center Raleway highlights" style={{ display:(section=='she-promotes' || catId!=0 && that.props.replaceTitle=='highlights' ? 'none' : 'block' )}}>
														{( 	!searchTxt && section!='term' ?
															<span>{ that.props.replaceTitle }</span>:
															<span>results of { decodeURIComponent(searchTxt) }</span>
														)}
													</h2>
													*/}
											</div>
								}

								fullWidthCount++;
								return (
									<div key={index/(articleColumn+1)} className="full-width clearfix">
										{tmpAds}
										<div className="grid-article-content">{tmpGridsArticle}</div>
										<div className="grid-article-ad">{tmpGridsAd}</div>
									</div>
								)
							}
						})
					}
					{loadBtn}
				</div>
			 );
         //Apply on all sites
		 }else if( page <= 2 /* && (document.querySelector('meta[name="baseURL"]').content.indexOf('.she.com') != -1)*/){
			 return <div>
                 <div className="grid-article-content grid-article-content-loadmore">
                     <div className="block-article-loadmore" onClick={this.getLatestArticles}>
                         <div className="btn btn-loadmore text-center Abel">
                             <div className="btn-loadmore-over"></div>
                             <div className="btn-loading">
                                 <span className="modal-pulsate" id="modal-bit-loader"></span>
                             </div>
                             <span>load more<i className="icon-arr_down-01"></i></span>
                         </div>
                     </div>
                 </div>
			 </div>
		 }else{
             return <div></div>
         }
	 }
}

export default Articles;


// WEBPACK FOOTER //
// ./src/Articles.js